import useMemeberInfo from "./useMemeberInfoHook";

const useWebsiteModules = () => {
   const {memberProfile} = useMemeberInfo();
  const { website_modules: websiteModules = {} } = memberProfile;

  return  websiteModules ;
};

export default useWebsiteModules;
